/**
 * Beta environment configuration
 * For beta.ealev.ru deployment
 */
export const environment = {
  production: true,
  apiUrl: '/api/v1',
  websocketUrl: '',
  appName: 'Levea Repricer (Beta)',
  version: '1.0.0-beta',
  gitlabUrl: '',
  // Never skip auth in beta
  skipAuth: false,
  diagnosticCaptureEnabled: true,
  feedbackPollingEnabled: true,
  // Keycloak: включён для beta
  useKeycloakAuth: true,
  keycloak: {
    url: 'https://auth.ealev.ru',  // БЕЗ порта (443 по умолчанию для HTTPS)
    realm: 'levea',
    clientId: 'levea-frontend',
  },
  features: {
    enableWebSocket: true,
    enablePWA: true,
    enableAnalytics: true,
    enableNotifications: true,
    enableRealTimeAlerts: true,
    enablePerformanceMonitoring: true
  },
  api: {
    timeout: 30000,
    retries: 3
  },
  cache: {
    ttl: 300000, // 5 minutes for beta (faster feedback)
    enableCaching: true
  },
  websocket: {
    reconnectInterval: 5000,
    maxReconnectAttempts: 10,
    timeout: 30000,
    heartbeatInterval: 30000,
    messageQueueSize: 1000,
    enableBatching: true,
    batchInterval: 1000,
    enableCompression: true,
    namespaces: {
      prices: '/prices',
      alerts: '/alerts',
      dashboard: '/dashboard',
      analytics: '/analytics'
    }
  },
  realtime: {
    priceUpdateThreshold: 5,
    alertRetentionDays: 14,
    maxHistoryEntries: 100,
    volatilityCalculationPeriod: 10,
    marketTrendCalculationHours: 24,
    competitorPriceUpdateInterval: 60000,
    enablePredictiveAlerts: true,
    batchSize: 50,
    throttleMs: 1000
  },
  monitoring: {
    enablePerformanceTracking: true,
    metricsReportingInterval: 60000,
    errorReportingThreshold: 5,
    connectionQualityThresholds: {
      excellent: 0.95,
      good: 0.8,
      poor: 0.5
    }
  }
};
